import { render, staticRenderFns } from "./PageForGov.vue?vue&type=template&id=8c02c186&scoped=true&"
import script from "./PageForGov.vue?vue&type=script&lang=js&"
export * from "./PageForGov.vue?vue&type=script&lang=js&"
import style0 from "./PageForGov.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PageForGov.vue?vue&type=style&index=1&id=8c02c186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c02c186",
  null
  
)

export default component.exports